import React, { useState, Fragment, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"

import {
  Button,
  ConfirmationModal,
  OrdersGroupPrintButton,
  OrdersSetAsViewedButton
} from "components"
import { cancelOrder } from "services"
import { isInPosDevice } from "utils"
import ApprovePaymentModal from "./ApprovePaymentModal"
import classes from "./PoFooter.module.scss"
import clsx from "clsx"

const PoFooter = (props) => {
  const {
    setOrders,
    selectedOrders,
    setSelectedOrders
  } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)
  const [openCancelModal, setOpenCancelModal] = useState(false)
  const [openPaymentApproveModal, setOpenPaymentApproveModal] = useState(false)

  const unmount = useRef(false)

  const handleCancelOrders = async () => {
    setSending(true)

    const orderIds =
      Object.keys(selectedOrders)

    for (const orderId of orderIds) {
      try {
        await cancelOrder(
          orderId,
          {
            refundType: "cash",
            cancelReasons: ""
          }
        )

        if (unmount.current) return

        setOrders(prev =>
          prev.map(o =>
            o._id === orderId
              ? { ...o, orderStatus: "canceled" }
              : o
          )
        )

        setOpenCancelModal(false)
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  const haveSelectedOrders =
    Object.keys(selectedOrders).length > 0

  const showGroupPrintButton = !isInPosDevice()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["footer"]}>
        <OrdersSetAsViewedButton
          orderStatus="pending"
          setOrders={setOrders}
        />

        {
          showGroupPrintButton &&
          <OrdersGroupPrintButton
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
          />
        }

        {
          haveSelectedOrders &&
          <Button
            color="success"
            onClick={() => setOpenPaymentApproveModal(true)}
            className={clsx(
              classes["approve"],
              isLtr && classes["approve-ltr"]
            )}
          >
            {t("تایید_پرداخت_ها")}
          </Button>
        }

        {
          haveSelectedOrders &&
          <Button
            color="warning"
            onClick={() => setOpenCancelModal(true)}
            className={clsx(
              classes["approve"],
              isLtr && classes["approve-ltr"]
            )}
          >
            {t("لغو_پرداخت")}
          </Button>
        }
      </div>


      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارشات_را_لغو_کنید")}
        show={openCancelModal}
        onExited={() => setSending(false)}
        onConfirm={handleCancelOrders}
        onHide={() => setOpenCancelModal(false)}
        loading={sending}
      />

      <ApprovePaymentModal
        setOrders={setOrders}
        selectedOrders={selectedOrders}
        setSelectedOrders={setSelectedOrders}
        openPaymentApproveModal={openPaymentApproveModal}
        setOpenPaymentApproveModal={setOpenPaymentApproveModal}
      />
    </Fragment>
  )
}

export default PoFooter